import React from 'react';

import './NotFound.scss';

const NotFound = (): JSX.Element => {
  return (
    <div className="not-found">
      <h2>Application not found.</h2>
    </div>
  );
};

export default NotFound;
